import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { Entities, Entry, Login, LoginError, Success } from "../pages";
import { ROUTES_PATH } from "../utils/constants";
import { useEffect } from "react";
import { QuitModal } from "../components/QuitModal";
import { Loader } from "../components/Loader";
import { FlowStep, Header } from "../components";
import { UnknownError } from "../pages/UnknownError/UnknownError";
import { useSelector } from "react-redux";
import { Landing } from "../pages/Landing";
import { IRootState } from "../redux/store";
import InsightService from "../services/Insight";

interface RoutesProps {
    loadingEvent?: (arg0: boolean) => void;
    closingEvent?: (arg0?: boolean) => void;
}

const AppRoutes: React.FC<RoutesProps> = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const loading = useSelector((state: IRootState) => state.loader.value);
    const modalOpen = useSelector((state: IRootState) => state.modal.value);
    const pepperOne = useSelector((state: IRootState) => state.params.value.pepperOne);
    const flowStep = useSelector((state: IRootState) => state.params.value.flowStep);
    const step = useSelector((state: IRootState) => state.header.value.step);

    const recieveMessage = (event: any) => {
        if (event.data.type === 'PEPPER_ONE' && event.data.message === 'return') {
            navigate(-1);
        }
    }

    useEffect(() => {
        InsightService.logPageView(pathname);
    }, [pathname]);

    useEffect(() => {
        if (loading) {
            const modal = document.getElementById('bankreader-modal');
            modal && modal.scrollTo(0, 0);
        }
    }, [loading]);

    useEffect(() => {
        if (pepperOne) {
            window.addEventListener('message', recieveMessage);
        }
    }, []);


    return (
        <>
            <div id="bankreader-modal" className={`pepper-container ${loading && 'pepper-loading-state'}`}>
                {loading && <Loader />}
                {!pepperOne && <Header />}
                <div className={`pepper-body`}>
                    {modalOpen && <QuitModal />}
                    {step && !flowStep && <FlowStep step={step} wrapperPosition={pathname === ROUTES_PATH.LOGIN ? 'absolute' : 'relative'} />}
                    <div className={`flex-auto ${pathname === ROUTES_PATH.ENTITIES ? 'pepper-entities-page' : 'pepper-full-height'}`}>
                        <Routes>
                            <Route path={ROUTES_PATH.LANDING} element={<Landing />} />
                            <Route path={ROUTES_PATH.ENTRY} element={<Entry />} />
                            <Route path={ROUTES_PATH.ENTITIES} element={<Entities />} />
                            <Route path={ROUTES_PATH.LOGIN} element={<Login />} />
                            <Route path={ROUTES_PATH.SUCCESS} element={<Success />} />
                            <Route path={ROUTES_PATH.LOGIN_ERROR} element={<LoginError />} />
                            <Route path={ROUTES_PATH.UNKNOWN_ERROR} element={<UnknownError />} />
                        </Routes>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AppRoutes;